import Dexie, { Table } from "dexie";

import { ProcessingStatus } from "@/features/intelliflow/constants/documentParser.constants";
import { UploadTask } from "@/features/intelliflow/interfaces/documentParser.interfaces";

export interface UploadTaskRecord extends UploadTask {
  id: string;
  status: ProcessingStatus;
}

class UploadQueueDB extends Dexie {
  uploads!: Table<UploadTaskRecord, string>;
  constructor() {
    super("UploadQueueDB");
    this.version(1).stores({
      uploads: "id",
    });
  }
}
export const uploadQueueDb = new UploadQueueDB();
